import { render, staticRenderFns } from "./Organize.vue?vue&type=template&id=83db39a8&scoped=true&"
import script from "./Organize.vue?vue&type=script&lang=js&"
export * from "./Organize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83db39a8",
  null
  
)

export default component.exports